import { useState, useEffect } from 'react'

// Components
import { Button, IconCheck, IconPen } from '@tracklib/kit'
import { Input } from 'components/form/inputs'

// Utils
import styles from './contactperson.css'

type ContactPersonProps = {
  onReview: boolean
  name?: string
  email?: string
  typeOfRights?: string
}

const validateName = (value: string) => {
  let error
  if (!value) {
    error = 'A name is required'
  }
  return error
}

const validateEmail = (value: string) => {
  let error
  if (!value) {
    error = 'An email is required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = 'Invalid email address'
  }
  return error
}

const ContactPerson = (props: ContactPersonProps): JSX.Element => {
  const { onReview, name, email, typeOfRights } = props
  const [isEditing, setIsEditing] = useState(true)

  useEffect(() => {
    if (onReview) {
      setIsEditing(false)
    }
  }, [onReview])

  if (!isEditing) {
    return (
      <div className={styles.displayWrapper}>
        <div className={styles.contactDetails}>
          {name && <div className={styles.textData}>{name}</div>}
          <div className={styles.textData}>{email}</div>
        </div>
        {onReview && !isEditing && (
          <Button className={styles.btnEdit} variant="outline" onClick={() => setIsEditing(!isEditing)}>
            <IconPen />
          </Button>
        )}
      </div>
    )
  }

  return (
    <div className={styles.editingWrapper}>
      <div className={styles.contactDetails}>
        <Input
          className={styles.inputField}
          id={`${typeOfRights}_rights_name`}
          name={`${typeOfRights}_rights_name`}
          type="text"
          placeholder="Name of person/entity"
          validate={validateName}
        />
        <Input
          className={styles.inputField}
          id={`${typeOfRights}_rights_email`}
          name={`${typeOfRights}_rights_email`}
          type="email"
          autoComplete="email"
          placeholder="Email"
          validate={validateEmail}
        />
      </div>
      {onReview && isEditing && (
        <Button className={styles.btnEditConfirm} onClick={() => setIsEditing(!isEditing)}>
          <IconCheck />
        </Button>
      )}
    </div>
  )
}

export default ContactPerson
